import actionTypes from '../../../../../../actions/Ui/Views/Admin/Market/Editor/actionTypes';

const initialState = {
  isLoadingStates: false,
  isUpdating: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING_STATES:
      return {
        ...state,
        isLoadingStates: true,
      };
    case actionTypes.LOADED_STATES:
      return {
        ...state,
        isLoadingStates: false,
      };
    case actionTypes.UPDATING:
      return {
        ...state,
        isUpdating: true,
      };
    case actionTypes.UPDATED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
